import { render, staticRenderFns } from "./BuddhaDetail.vue?vue&type=template&id=5309906f&scoped=true"
import script from "./BuddhaDetail.vue?vue&type=script&lang=js"
export * from "./BuddhaDetail.vue?vue&type=script&lang=js"
import style0 from "./BuddhaDetail.vue?vue&type=style&index=0&id=5309906f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309906f",
  null
  
)

export default component.exports